// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"d1c01601","364":"593409b8","453":"04af9047","503":"d96737fa","623":"b80ebda0","783":"44b049d7","881":"dc1a69ab"}[chunkId] + ".chunk.js";
};